import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function IncreaseIcon({
    size = ICON_DEFAULT_SIZE,
    color = ICON_DEFAULT_COLOR, ...rest
}:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <rect x="2" y="2" width="20" height="20" rx="10" fill={color}/>
            <path d="M12.0112 6.98865V17.0114" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M7 12L17.0227 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>

    );
}

export default IncreaseIcon;
